export default __webpack_public_path__ + "static/media/Facilities-CACS-16.5da714bd.jpg";